import React from 'react';
import './assets/loading.scss';

const ProductGridLoading = () => <div className='loading loading--grid' />;

export default ProductGridLoading;
